import React from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
} from "@mui/material";
import SearchIcon       from "@mui/icons-material/Search";
import ClearIcon        from "@mui/icons-material/Clear";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { POPPINS } from "./adminConstants";

const UserMetricsFilters = ({
  search,
  isActiveFilter,
  exporting,
  exportingChat,
  exportingLogin,
  onSearchChange,
  onClearSearch,
  onStatusChange,
  onExport,
  onExportChat,
  onExportLogin,
}) => (
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, px: 3, py: 1.5, alignItems: "center" }}>
    <TextField
      size="small"
      placeholder="Search by name or email…"
      value={search}
      onChange={onSearchChange}
      sx={{ flex: "1 1 200px", minWidth: 200 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "#9e9e9e" }} />
          </InputAdornment>
        ),
        endAdornment: search ? (
          <InputAdornment position="end">
            <IconButton size="small" onClick={onClearSearch}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
        sx: { ...POPPINS, fontSize: "0.85rem" },
      }}
    />

    <FormControl size="small" sx={{ minWidth: 130 }}>
      <InputLabel sx={POPPINS}>Status</InputLabel>
      <Select value={isActiveFilter} label="Status" onChange={onStatusChange} sx={POPPINS}>
        <MenuItem value="">All</MenuItem>
        <MenuItem value="1">Active</MenuItem>
        <MenuItem value="0">Inactive</MenuItem>
      </Select>
    </FormControl>

    <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
      <Button
        variant="outlined"
        size="small"
        startIcon={exportingChat ? <CircularProgress size={13} /> : <FileDownloadIcon />}
        onClick={onExportChat}
        disabled={exportingChat}
        sx={{ ...POPPINS, fontSize: "0.78rem", textTransform: "none", borderColor: "#bdbdbd", color: "#555" }}
      >
        Chat History CSV
      </Button>
      <Button
        variant="outlined"
        size="small"
        startIcon={exportingLogin ? <CircularProgress size={13} /> : <FileDownloadIcon />}
        onClick={onExportLogin}
        disabled={exportingLogin}
        sx={{ ...POPPINS, fontSize: "0.78rem", textTransform: "none", borderColor: "#bdbdbd", color: "#555" }}
      >
        Login Log CSV
      </Button>
      <Button
        variant="outlined"
        size="small"
        startIcon={exporting ? <CircularProgress size={13} /> : <FileDownloadIcon />}
        onClick={onExport}
        disabled={exporting}
        sx={{ ...POPPINS, fontSize: "0.78rem", textTransform: "none", borderColor: "#bdbdbd", color: "#555" }}
      >
        Users CSV
      </Button>
    </Box>
  </Box>
);

export default UserMetricsFilters;
